export const policyGroups = Object.freeze([
  {
    label: "Orders & delivery",
    links: [
      ["Terms of Sale", "/terms-of-sale"],
      ["Shipping & Delivery", "/shipping"],
      ["Lost, Delayed & Damaged Packages", "/package-issues"],
      ["Returns, Refunds & Exchanges", "/returns"],
      ["Order Cancellation", "/order-cancellation"],
      ["International Orders & Customs", "/international-orders"],
      ["Payment, Pricing & Fraud", "/payment-pricing"],
      ["Discounts & Promotions", "/discounts-promotions"],
      ["Sale & Clearance", "/sale-clearance"],
    ],
  },
  {
    label: "Products & content",
    links: [
      ["Product Descriptions & Variation", "/product-information"],
      ["Product Safety & Care", "/product-safety"],
      ["Support Evidence & Customer Content", "/customer-content"],
      ["Intellectual Property", "/intellectual-property"],
      ["Packaging & Sustainability", "/packaging"],
    ],
  },
  {
    label: "Privacy & site use",
    links: [
      ["Privacy Policy", "/privacy"],
      ["Consumer Data Rights", "/data-rights"],
      ["Cookie & Storage Notice", "/cookies"],
      ["Terms of Use", "/terms"],
      ["Accessibility", "/accessibility"],
      ["Complaints & Policy Updates", "/complaints"],
      ["Contact Information", "/contact-policy"],
      ["FAQ", "/faq"],
    ],
  },
]);

export const policyLinks = Object.freeze(policyGroups.flatMap((group) => group.links));
